// extracted by css-extract-rspack-plugin
export default {"maxButton":"maxButton-o7Lzr1"};